import { InjectionToken } from '@angular/core';
import { Environment } from "../../../types/environment";

export const ENVIRONMENT_TOKEN: InjectionToken<Environment> = new InjectionToken('ENVIRONMENT_TOKEN');
